import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b3b7ad6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_cheap = _resolveComponent("cheap")!

  return (_ctx.column.key === 'index')
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createTextVNode(_toDisplayString(_ctx.index + 1), 1)
      ], 64))
    : (_ctx.column.key === 'tripNumber')
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 1,
          class: "TripsLink",
          to: `/tms/trips/${_ctx.row.id}`,
          target: "_blank"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.row.tripNumber), 1)
          ]),
          _: 1
        }, 8, ["to"]))
      : (_ctx.column.key === 'paymentBySupplierNumber')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            (Boolean(_ctx.row.paymentBySupplierNumber))
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  class: "TripsLink",
                  to: `/rpp/ltl/${_ctx.row.paymentBySupplierId}`,
                  target: "_blank"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.row.paymentBySupplierNumber), 1)
                  ]),
                  _: 1
                }, 8, ["to"]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode("-")
                ], 64))
          ], 64))
        : (_ctx.isDirection)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _createTextVNode(_toDisplayString(_ctx.row.fromCity.name) + " - " + _toDisplayString(_ctx.row.toCity.name), 1)
            ], 64))
          : (_ctx.column.key === 'transportType')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                _createTextVNode(_toDisplayString(_ctx.row.transportType.name), 1)
              ], 64))
            : (_ctx.column.key === 'company' && _ctx.row.company)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                  _createTextVNode(_toDisplayString(_ctx.row.company.shortName), 1)
                ], 64))
              : (_ctx.column.key === 'status')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                    (_ctx.row.status)
                      ? (_openBlock(), _createBlock(_component_cheap, {
                          key: 0,
                          class: _normalizeClass(_ctx.getCheapClass)
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.getCheapTitle), 1)
                          ]),
                          _: 1
                        }, 8, ["class"]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_1, " - "))
                  ], 64))
                : (_ctx.column.key === 'isProject')
                  ? (_openBlock(), _createElementBlock("i", {
                      key: 7,
                      class: _normalizeClass(_ctx.getCheckOrTimesIcon(_ctx.row.isProject))
                    }, null, 2))
                  : (_ctx.column.key === 'createdAt')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
                        _createTextVNode(_toDisplayString(_ctx.formatDateWithTimeFromBackend(_ctx.row.createdAt)), 1)
                      ], 64))
                    : (_ctx.column.key === 'expectedDate')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 9 }, [
                          _createTextVNode(_toDisplayString(_ctx.formatDateWithTimeFromBackend(_ctx.row.expectedDate)), 1)
                        ], 64))
                      : (_ctx.column.key === 'arrivalDate')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 10 }, [
                            _createTextVNode(_toDisplayString(_ctx.formatDateWithTimeFromBackend(_ctx.row.arrivalDate)), 1)
                          ], 64))
                        : (_ctx.column.key === 'departureDate')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 11 }, [
                              _createTextVNode(_toDisplayString(_ctx.getDepartureDate(_ctx.row.departureDate)), 1)
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 12 }, [
                              _createTextVNode(_toDisplayString(_ctx.row[_ctx.column.key] || '-'), 1)
                            ], 64))
}